// src/components/SuccessStories/SuccessStories.jsx

import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";

import AOS from "aos";
import "aos/dist/aos.css";
import "swiper/css";
import "swiper/css/free-mode";

import "./successStories.scss";

/* ===============================
   VIMEO POSTER
================================ */

function getVimeoPoster(url) {
  const match = url.match(/video\/(\d+)/);
  return match
    ? `https://vumbnail.com/${match[1]}.jpg`
    : "";
}

/* ===============================
   REEL CARD
================================ */

function ReelCard({ src }) {
  const [play, setPlay] = useState(false);

  const poster = getVimeoPoster(src);

  return (
    <div className="reel-card">

      {!play ? (
        <div
          className="reel-poster"
          style={{
            backgroundImage: `url(${poster})`,
          }}
          onClick={() => setPlay(true)}
        >

          {/* Dark overlay */}
          <div className="reel-overlay"></div>

          {/* Play Button */}
          <div className="play-wrapper">

            <span className="wave wave1"></span>
            <span className="wave wave2"></span>
            <span className="wave wave3"></span>

            <div className="play-btn">
              ▶
            </div>

          </div>

        </div>
      ) : (
        <iframe
          src={`${src}?autoplay=1&muted=0&controls=1`}
          className="reel-iframe"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Client Success Reel"
        />
      )}

    </div>
  );
}

/* ===============================
   MAIN COMPONENT
================================ */

export default function SuccessStories() {

  const swiperRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
    });
  }, []);

  /* ===============================
     VIMEO REELS
  ================================ */

  const reels = [
    "https://player.vimeo.com/video/1144761531",
    "https://player.vimeo.com/video/1144761513",
    "https://player.vimeo.com/video/1144761474",
    "https://player.vimeo.com/video/1144761452",
    "https://player.vimeo.com/video/1144761423",
    "https://player.vimeo.com/video/1144761562",
  ];

  const loopReels = [...reels, ...reels, ...reels];

  /* ===============================
     HOVER HANDLERS
  ================================ */

  const handleMouseEnter = () => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.stop();
    }
  };

  const handleMouseLeave = () => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.start();
    }
  };

  return (
    <section className="success-section">

      {/* ===============================
          HEADER
      ================================ */}

      <div className="success-header">

        <h2
          className="title"
          data-aos="fade-up"
        >
          Success Stories
        </h2>

        <p
          className="subtitle"
          data-aos="fade-up"
        >
          Clients don’t just love us because we save them time.
          <br />
          It’s because we also get them results.
        </p>

        <button
          className="view-btn"
          data-aos="zoom-in"
        >
          View All Client Success
        </button>

      </div>

      {/* ===============================
          REEL SLIDER
      ================================ */}

      <div
        className="reel-slider-wrapper"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >

        <Swiper
          modules={[Autoplay, FreeMode]}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}

          loop={true}

          freeMode={{
            enabled: true,
            momentum: true,
            momentumRatio: 0.6,
            momentumVelocityRatio: 0.6,
          }}

          grabCursor={true}

          allowTouchMove={true}

          spaceBetween={22}

          speed={7000}

          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}

          breakpoints={{
            0: {
              slidesPerView: 1.25,
              spaceBetween: 14,
            },

            480: {
              slidesPerView: 1.7,
              spaceBetween: 16,
            },

            576: {
              slidesPerView: 2.3,
              spaceBetween: 18,
            },

            768: {
              slidesPerView: 3.2,
              spaceBetween: 20,
            },

            992: {
              slidesPerView: 4,
              spaceBetween: 20,
            },

            1200: {
              slidesPerView: 5,
              spaceBetween: 22,
            },
          }}

          className="story-slider"
        >

          {loopReels.map((src, index) => (

            <SwiperSlide key={index}>

              <ReelCard src={src} />

            </SwiperSlide>

          ))}

        </Swiper>

      </div>

    </section>
  );
}